/**
 * TOKCHAN Main Application Component
 *
 * Root React component that orchestrates the entire application layout.
 * Uses ThreePanelLayout for the main dashboard view.
 */

import React, { useState, useEffect } from 'react';
import { ThreePanelLayout } from './components/layouts/ThreePanelLayout.js';
import { LoadingScreen } from './components/layouts/LoadingScreen.js';
import { logger } from './libs/utils/logger.js';

interface AppProps {
    onReady?: () => void;
}

export const App: React.FC<AppProps> = ({ onReady }) => {
    const [showLoading, setShowLoading] = useState(true);
    const [fadeOut, setFadeOut] = useState(false);

    useEffect(() => {
        const initializeApp = async () => {
            try {
                // ThreeBackgroundの初期化を待つ（少し長めに）
                await new Promise(resolve => setTimeout(resolve, 500));

                // フェードアウト開始
                setFadeOut(true);

                // フェードアウトアニメーション完了を待つ
                await new Promise(resolve => setTimeout(resolve, 500));

                // ローディング画面を非表示
                setShowLoading(false);
                logger.info('🎉 App component ready');
                onReady?.();
            } catch (error) {
                logger.error('Failed to initialize App:', error);
            }
        };

        initializeApp();
    }, [onReady]);

    return (
        <>
            {/* ThreePanelLayoutを常にレンダリング（Three.js背景が先に初期化される） */}
            <ThreePanelLayout />
            {/* ローディング画面はその上に表示され、フェードアウト後に消える */}
            {showLoading && <LoadingScreen fadeOut={fadeOut} />}
        </>
    );
};

export default App;
